import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  FC,
  PropsWithChildren,
} from "react";
import { LoadingContext, LoadingGetterContext } from "./LoadingContext";
import { topbar } from ".";

const LoadingMiddleware: FC<PropsWithChildren<{ isLoading?: any }>> = ({
  children,
  isLoading = false,
}) => {
  const timeout: any = useRef();
  const [loading, setLoading] = useState(isLoading);

  const start = useCallback((str: any) => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      topbar.show();
    }, 70);

    setLoading(str);
  }, []);

  const done = useCallback(() => {
    clearTimeout(timeout.current);
    topbar.hide();
    setLoading(false);
  }, []);

  const restart = useCallback(() => {
    clearTimeout(timeout.current);
    topbar.hide();
    topbar.show();
  }, []);

  return (
    <LoadingGetterContext.Provider value={loading}>
      <LoadingContext.Provider value={{ start, done, restart }}>
        {children}
      </LoadingContext.Provider>
    </LoadingGetterContext.Provider>
  );
};

export default LoadingMiddleware;
